export const RELATIONSHIP_TABS = [
  { key: 'referred', label: 'Referred', index: 0, ownerPath: '/u/connections/referrals' },
  { key: 'followers', label: 'Followers', index: 1, ownerPath: '/u/connections/followers' },
  { key: 'following', label: 'Following', index: 2, ownerPath: '/u/connections/following' },
  { key: 'favorites', label: 'Favorites', index: 3, ownerPath: '/u/connections/favorites' },
  { key: 'favorited', label: 'Favorited', index: 4, ownerPath: '' },
  { key: 'gifted', label: 'Gifted', index: 5, ownerPath: '' },
] as const;

export type RelationshipKey = typeof RELATIONSHIP_TABS[number]['key'];

export function parseRelationshipTab(raw: string | null | undefined): number {
  if (raw == null || !/^\d+$/.test(raw)) return 0;
  const value = Number(raw);
  if (value < 0 || value > 5) return 0;
  return value;
}

export function relationshipIndex(list: RelationshipKey): number {
  return RELATIONSHIP_TABS.find((tab) => tab.key === list)?.index ?? 0;
}

export function detailStatPath(channel: string, index: number): string {
  return `/u/connections/referrers/${encodeURIComponent(channel)}?tab=${parseRelationshipTab(String(index))}`;
}

export function connectionStatPath(list: RelationshipKey, channel: string, own: boolean): string {
  const tab = RELATIONSHIP_TABS.find((item) => item.key === list);
  if (own && tab?.ownerPath) return tab.ownerPath;
  return detailStatPath(channel, tab?.index ?? 0);
}

export function replaceTabSearch(search: string, index: number): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  params.set('tab', String(parseRelationshipTab(String(index))));
  return `?${params.toString()}`;
}
